function Footer() {
  return (
    <footer className="footer">
      <p className="footer__caption">&copy;&nbsp;2023 Михаил Седлачек</p>
    </footer>
  );
}

export default Footer;
